import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Flexbox from '../Flexbox/index.js';
import styles from './FlexboxPane.module.scss.js';

var _excluded = ["children", "className", "flexboxContainer"];
var FlexboxPaneContainer = function FlexboxPaneContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    flexboxContainer = _ref.flexboxContainer,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Flexbox.Container, _extends({
    className: cx(styles.flexboxPaneContainer, className)
  }, flexboxContainer, props), children);
};
FlexboxPaneContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  flexboxContainer: PropTypes.object
};
FlexboxPaneContainer.defaultProps = {
  flexboxContainer: {
    alignItems: 'start',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
};

export { FlexboxPaneContainer as default };
//# sourceMappingURL=FlexboxPaneContainer.js.map
